import { render, staticRenderFns } from "./SkillsSection.vue?vue&type=template&id=df648030&scoped=true"
import script from "./SkillsSection.vue?vue&type=script&lang=js"
export * from "./SkillsSection.vue?vue&type=script&lang=js"
import style0 from "./SkillsSection.vue?vue&type=style&index=0&id=df648030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df648030",
  null
  
)

export default component.exports